/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-fs-config.js
   asset: assets/skon-fs-config.js
   Modulo: Free Shipping Test (FS)
   Versione: 1.3.0 — 8 ottobre 2026 — 16:02

   CHANGELOG
   ─────────
   1.3.0 (8 ott 2026) — SOGLIA PILOTABILE DAL CUSTOMIZER
     Aggiunto ponte Customizer → JS (snippets/skon-fs-settings.liquid),
     stesso pattern già in uso per il modulo Gift With Purchase (vedi
     skon-gift-config.js / skon-gift-settings.liquid). Da questa versione
     thresholds.groupA è sovrascritto a runtime da window.SKON_FS_SETTINGS
     se presente, leggendo il valore da Impostazioni tema → "Skön —
     Spedizione gratuita (soglia e costo)" → campo "Soglia spedizione
     gratuita (€)". Il valore hardcoded qui sotto resta come fallback
     (retrocompatibile: ponte assente ⇒ si usa il default). thresholds.groupB
     NON è toccato dal ponte: resta il valore dormiente indipendente, per
     non legare un eventuale A/B futuro al campo pensato per l'esperienza
     "tutti NC" corrente. Vedi anche snippets/cart-summary.liquid, che legge
     la stessa impostazione direttamente in Liquid (nessun ponte necessario
     lì, essendo già lato server) — ed è lì che va anche il nuovo campo
     "Costo di spedizione stimato (€)", che sostituisce l'hardcode €6,90.
     ATTENZIONE: i campi del Customizer controllano SOLO la UX. La tariffa
     di spedizione REALE si imposta separatamente in Impostazioni →
     Spedizione e consegna: vanno tenuti allineati a mano (vedi il
     paragrafo di avviso nella sezione Customizer stessa).

   1.2.2 (8 ott 2026) — RIPRISTINO SOGLIA 49€ (allineamento a tariffa nativa)
     thresholds.groupA: 2900 → 4900. Motivo: la tariffa di spedizione nativa
     Shopify (Impostazioni → Spedizione → Profilo generale → Italia) è stata
     riportata a €49 dopo la 1.2.1 del 28 set 2026 (che l'aveva allineata a
     €29). La UX del modulo era rimasta ferma su €29, disallineata dalla
     tariffa reale — questo aggiornamento la riallinea. Nessuna modifica a
     ab.enabled (false) né a forceGroup ('A'): il meccanismo A/B resta
     chiuso esattamente come nelle versioni precedenti. groupB resta a 2900
     (29,00 €), dormiente, invariato.

   1.2.1 (28 set 2026) — SOGLIA UNICA 29€ (allineamento a tariffa nativa)
     thresholds.groupA: 4900 → 2900. groupA e groupB ora coincidono (29€).
     Nessuna modifica a ab.enabled (false) né a forceGroup ('A'): il
     meccanismo A/B resta chiuso esattamente come nella 1.2.0, cambia solo
     il valore che groupA applica. Motivo: la tariffa di spedizione nativa
     Shopify (Impostazioni → Spedizione → Profilo generale → Italia) è
     già impostata a soglia €29 per la spedizione gratuita; la UX del
     modulo (progress bar, fallback Liquid in cart-summary.liquid) era
     rimasta disallineata su €49. Questo aggiornamento allinea il tema al
     comportamento reale già attivo in cassa.

   1.2.0 (17 giu 2026) — CHIUSURA A/B TEST (mantiene esperienza drawer)
     ab.enabled: true → false (forceGroup resta 'A'). Stop split 50/50: tutti
     gli NC al controllo (49€), niente 29€, niente SK-FS29. Progress bar +
     cross-sell + onboarding restano per tutti. A/B 26 mag–15 giu: effetto
     29€ promo-dipendente, non strutturale → no rollout.

   1.1.0 (28 mag 2026) — Esternalizzata versione Storefront API Shopify
     - Aggiunta sezione `shopify.storefrontApiVersion` (default '2026-04').
       Letta da skon-fs-suggestions.js v1.1.1 in _enrichWithDiscounts,
       dove prima era hardcoded. Nessuna modifica di comportamento:
       stessa versione di API, solo origine diversa (centralizzata).
       Shopify deprecates le versioni Storefront API ogni ~12 mesi,
       avere un solo punto di aggiornamento riduce il debito futuro.

   1.0 (maggio 2026) — Release iniziale.

   FONTE DI VERITÀ (da v1.3.0)
   ───────────────────────────
   Il valore OPERATIVO di thresholds.groupA vive nel Customizer
   (Impostazioni tema → "Skön — Spedizione gratuita (soglia e costo)") e
   arriva qui via window.SKON_FS_SETTINGS (ponte
   snippets/skon-fs-settings.liquid, caricato PRIMA di questo file — vedi
   theme.liquid). Il default hardcoded in thresholds.groupA qui sotto è
   solo il fallback se il ponte è assente. thresholds.groupB resta sempre
   hardcoded (non pilotato dal Customizer): è il valore dormiente del
   gruppo B, indipendente per un eventuale A/B futuro.

   FILOSOFIA
   ─────────
   Questo file contiene TUTTI i parametri editabili del modulo Free Shipping.
   Modificare qui per:
   - Accendere/spegnere il modulo
   - Cambiare le soglie A/B
   - Cambiare il codice sconto auto-applicato
   - Cambiare la collection dei prodotti filler
   - Disabilitare lo split A/B (forza tutti gli NC al gruppo A o B)
   - Cambiare i nomi degli eventi GA4

   Il modulo `skon-fs-test.js` legge questi valori e si comporta di conseguenza.
   Non modificare la logica interna del modulo per cambiare un parametro:
   tutto deve essere editabile da qui.

   DEPLOYMENT: caricare PRIMA di skon-fs-test.js in theme.liquid.
══════════════════════════════════════════════════════════════════════ */

window.SKON_FS_CONFIG = {

  /* ── TOGGLE PRINCIPALE ──────────────────────────────────────────── */

  // false = il modulo non si registra a nulla, comportamento sito = attuale
  // true  = il modulo è attivo (poi filtrato da release.mode e audience)
  enabled: true,

  // Audience target del modulo. Per ora sempre 'NC'.
  // Gli RC vedono sempre l'esperienza nativa Shopify (soglia 49€,
  // allineata alla tariffa di spedizione configurata in Impostazioni
  // → Spedizione, "Profilo generale" → zona Italia).
  audience: 'NC',


  /* ── PIATTAFORMA SHOPIFY ────────────────────────────────────────── */

  // Parametri di integrazione tecnica con Shopify. Centralizzati qui
  // così l'aggiornamento (es. bump della versione Storefront API) avviene
  // in un solo punto invece di in N moduli.
  shopify: {
    // Versione della Shopify Storefront API usata dalle chiamate GraphQL
    // dei moduli FS. Attualmente letta da skon-fs-suggestions.js
    // (_enrichWithDiscounts, mutation cartCreate per il calcolo
    // coupon-aware dei prezzi delle card filler).
    //
    // Shopify deprecates le versioni Storefront API ogni ~12 mesi.
    // Verificare periodicamente (https://shopify.dev/docs/api/usage/versioning)
    // e bumpare quando una versione si avvicina alla deprecation.
    // Quando si bumpa, verificare che il payload della mutation usata in
    // skon-fs-suggestions sia ancora compatibile.
    storefrontApiVersion: '2026-04',
  },


  /* LIVE PRICE: prezzo reale sulle card di collection, home e quick-add.
     Letto da skon-live-price-core.js + skon-collection-live-price.js.
     enabled:false = comportamento nativo del tema ovunque (kill-switch).
     mode 'staging' = attivo SOLO con ?skon_lp_test=1 (clienti non lo vedono).
     mode 'live'    = attivo per tutti. */
  collectionLivePrice: {
    enabled: true,
    mode: 'live',
    warmup: true,
    batchSize: 24,
    timeoutMs: 6000,
    debounceMs: 120,
    scanDebounceMs: 150,
    rootMargin: '300px',
    paintModal: true,
    veilMaxMs: 2500,
    cartDebounceMs: 250,
    debug: false,
  },


  /* ── RELEASE MODE ───────────────────────────────────────────────── */

  // CONTROLLO DI VISIBILITÀ DEL MODULO IN PRODUZIONE
  //
  // Lo stesso pattern usato in nc-experience.js (SKON_NC_DEBUG):
  // i file sono caricabili in produzione senza rischio, ma il modulo
  // resta invisibile finché non passi a 'live'.
  //
  // - 'staging' = il modulo si attiva SOLO con ?skon_fs_test=1 nell'URL.
  //               Visitatori normali non lo vedono. Usalo per testare
  //               in produzione senza esporre il test ai clienti reali.
  //
  // - 'live'    = il modulo si attiva per tutti i NC (lancio ufficiale).
  //               Da questo momento tutti gli NC vedono la soglia
  //               configurata in `thresholds.groupA` (ab.enabled: false
  //               → forceGroup 'A').
  //
  // Per partire: 'staging' → tu testi → quando ok → 'live'.
  // Per spegnere: torna a 'staging' o metti enabled: false.
  release: {
    mode: 'live',

    // Parametro URL che sblocca il modulo in modalità staging.
    // Tienilo riservato. Cambialo se sospetti sia stato divulgato.
    unlockParam: 'skon_fs_test',
  },


  /* ── SOGLIE A/B ─────────────────────────────────────────────────── */

  // Importi in centesimi (Shopify-native: tutti i prezzi internamente sono cents)
  // Questi sono i DEFAULT di fallback. Da v1.3.0 il valore operativo di
  // groupA vive nel Customizer (Impostazioni tema → "Skön — Spedizione
  // gratuita (soglia e costo)") e arriva qui via window.SKON_FS_SETTINGS
  // (ponte snippets/skon-fs-settings.liquid, override in fondo al file).
  // groupA = controllo (default 49€, sovrascritto dal Customizer quando
  //          il ponte è presente)
  // groupB = trattamento (soglia ridotta 29€, dormiente — ab.enabled: false,
  //          forceGroup: 'A'. NON pilotato dal Customizer di proposito:
  //          resta indipendente per un eventuale A/B futuro)
  thresholds: {
    groupA: 4900,   // 49,00 € — fallback se il ponte Customizer è assente
    groupB: 2900,   // 29,00 €
  },


  /* ── A/B TEST ASSIGNMENT ────────────────────────────────────────── */

  ab: {
    // false = tutti i NC nel gruppo specificato in `forceGroup`
    // true  = split casuale 50/50, persistente per device via cookie
    enabled: false,

    // Usato solo quando enabled=false. Valori: 'A' o 'B'.
    forceGroup: 'A',

    // Durata del cookie di assegnazione (giorni).
    // 60gg per coerenza con skon_quiz_group esistente.
    cookieDays: 60,

    // Nome del cookie. Non modificare a test in corso (i visitatori già
    // assegnati perderebbero la loro variante).
    cookieName: 'skon_fs_group_v2',
  },


  /* ── CODICE SCONTO ──────────────────────────────────────────────── */

  // Coupon Shopify di tipo "Free Shipping" con minimo €29.
  // Auto-applicato al carrello dei NC gruppo B.
  // Da creare in Shopify Admin → Discounts:
  //   Type: Free shipping
  //   Method: Discount code
  //   Code: SK-FS29
  //   Minimum purchase requirement: €29,00
  //   Customer eligibility: All customers
  //   Usage limits: nessuno (o alto limite per sicurezza)
  //   Active dates: secondo durata test
  discountCode: 'SK-FS29',

  // Quando applicare il codice:
  // - 'on_cart_open': al primo open del cart drawer (più sicuro, meno chiamate)
  // - 'on_first_add': al primo add-to-cart (più aggressivo, applica anche se utente non apre mai il drawer)
  applyTrigger: 'on_first_add',


  /* ── CART/ORDER ATTRIBUTES ──────────────────────────────────────── */

  // Attributi scritti sul cart Shopify via /cart/update.js. Vengono
  // automaticamente trasferiti all'ordine come "Additional details"
  // (in API: order.note_attributes), e sono accessibili sia nell'Admin
  // di Shopify (visualizzati in chiaro nella scheda dell'ordine), sia
  // via Shopify Flow per automazioni come tagging, segmentazione, ecc.
  //
  // I nomi delle chiavi sono in italiano e leggibili perché compaiono
  // letteralmente nell'Admin Shopify e devono essere comprensibili
  // anche per chi non conosce il modulo (operations, customer service).
  //
  // Comportamento:
  // - "Tipo cliente" e "Gruppo A/B" sono sempre scritti (NC, RC, unknown)
  // - "Codice sconto" è scritto SOLO per il gruppo B (gli altri non lo applicano)
  //
  // Per cambiare il naming dei tag senza toccare il codice del modulo,
  // basta modificare le chiavi qui sotto.
  orderAttributes: {
    enabled: true,
    keys: {
      visitorType:  'Skön - Tipo cliente',   // valore: "NC" | "RC" | "unknown"
      group:        'Skön - Gruppo A/B',     // valore: "A" | "B"
      discountCode: 'Skön - Codice sconto',  // valore: stringa CFG.discountCode (solo gruppo B)
    },
  },


  /* ── COLLECTION FILLER ──────────────────────────────────────────── */

  // Collection Shopify da cui pescare i prodotti suggeriti come filler.
  // ID 679191511415 = "Prodotti Singoli" — contiene gli hero del brand
  // (Booster Collagene, Abrakadabra Glow/Soft Matt, sieri, creme...) cioè
  // prodotti che un visitatore vorrebbe realmente aggiungere al cart per
  // raggiungere la soglia. NB: l'handle ha un typo in produzione
  // ("acessori" con una sola C) ma il modulo usa l'ID, l'handle è solo
  // backup informativo.
  filler: {
    collectionId:     462274363665,
    collectionHandle: 'crea-la-tua-skincare-routine',

    // Numero massimo di prodotti da mostrare nel widget
    maxProducts: 6,

    // Strategia di selezione filler:
    // - 'cheapest_first':     più economici per primi (rapido raggiungimento soglia)
    // - 'closest_to_gap':     mostra il prodotto che più si avvicina al gap mancante
    // - 'closest_then_ascending':
    //                         primo slot = prodotto più vicino al gap;
    //                         slot successivi = altri prodotti in ordine crescente
    //                         di prezzo. Buon mix tra rapidità (primo slot
    //                         risolve subito) e scoperta progressiva (slot
    //                         successivi mostrano il catalogo dal meno caro).
    // - 'mixed':              mix dei due classici
    strategy: 'closest_then_ascending',

    // Se true, esclude dal widget i prodotti già presenti nel carrello
    excludeAlreadyInCart: true,

    // Se true, esclude i prodotti out-of-stock
    excludeOutOfStock: true,

    // Se true, esclude dal widget i prodotti con più di una variante
    // (es. fondotinta con tonalità diverse, oli labbra con colori diversi).
    //
    // Motivazione: il widget cross-sell serve a "chiudere l'ordine" alla
    // soglia free-shipping, non a vendere prodotti che richiedono
    // valutazione attenta (es. scegliere la tonalità giusta per la propria
    // pelle). Per quei prodotti la persona deve poter andare alla PDP e
    // valutare con calma. Mostrarli nel widget con un selettore di varianti
    // on-the-fly è UX rischioso (rischio scelta sbagliata, reso). Mostrarli
    // con redirect alla PDP fa "uscire" la persona dal drawer e abbassa
    // la conversion. La soluzione più sicura è non mostrarli affatto.
    excludeMultiVariant: true,

    // SAFETY MARGIN per la selezione filler quando ci sono sconti attivi.
    //
    // Problema risolto: quando un coupon (cart-level o line-level) è attivo
    // nel cart, il prezzo "vero" che il visitatore pagherà per un prodotto
    // suggerito può essere inferiore al prezzo di listino mostrato. Se il
    // widget suggerisce un prodotto da €10 per "chiudere l'ordine" a soglia
    // free-shipping, ma quel prodotto verrà scontato e pagato €7, allora
    // l'aggiunta NON chiude l'ordine come promesso.
    //
    // Soluzione: aumentiamo il gap richiesto del margin% quando ci sono
    // sconti attivi, così che anche scontato il prodotto suggerito chiuda
    // comunque la soglia. 0.30 (= 30%) coincide con la scontistica media
    // empirica di Skön sul sito.
    //
    // Quando NON ci sono sconti attivi nel cart, il margin NON viene
    // applicato (il widget mostra prodotti col gap esatto, come oggi).
    //
    // Per disattivare il safety margin: priceMarginWhenDiscounted: 0
    priceMarginWhenDiscounted: 0.30,
  },


  /* ── WIDGET MODES ──────────────────────────────────────────────────
     SKÖN custom (maggio 2026) — Il widget cross-sell sotto la lista
     prodotti del cart drawer ha 3 modalità di funzionamento, attivate
     dinamicamente in base allo stato del cart:

     1) FREE-SHIPPING (modalità storica): cart con subtotale che copre
        almeno il `gapTriggerPct` della soglia free-shipping (es. cart
        a €15 su soglia €29 = 51%). Mostra prodotti dalla collection
        `filler.collectionId` ordinati per chiudere il gap residuo.

     2) RELATED (modalità correlati): cart con subtotale ≥ threshold
        free-shipping OPPURE cart sotto soglia ma con gap > 50% del
        threshold (cioè troppo lontani per "chiudere", meglio
        suggerire prodotti correlati a quanto già nel cart). Pesca
        i prodotti via Shopify /recommendations/products.json
        sui top N item del cart per priceCents discendente.

     3) BESTSELLER (modalità cart vuoto): cart vuoto. Mostra una
        collection "best seller" curata via social proof.
  ─────────────────────────────────────────────────────────────────── */
  widgetModes: {

    // Soglia (in % della threshold free-shipping) sotto la quale
    // il widget passa da modalità FREE-SHIPPING a modalità RELATED.
    // Esempio: 0.50 = se il cart ha ≥ 50% della soglia, mostriamo
    // prodotti per chiudere; sotto al 50%, mostriamo correlati.
    // Stessa soglia usata per la visibilità della progress bar.
    gapTriggerPct: 0.50,

    // Numero massimo di chiamate parallele a /recommendations/products.json
    // in modalità RELATED. Prendiamo i top N item del cart per
    // priceCents discendente, deduplichiamo i risultati.
    relatedMaxApiCalls: 2,

    // Collection per la modalità BESTSELLER (cart vuoto).
    // Curata manualmente lato Shopify Admin con i prodotti più
    // venduti / più amati dalla community.
    bestseller: {
      collectionId:     695621943671,
      collectionHandle: 'best-seller-skon-cosmetics',
    },
  },


  /* ── WIDGET COPY (per modalità) ──────────────────────────────────── */
  widgetCopy: {

    // Modalità FREE-SHIPPING (chiusura ordine)
    freeShipping: {
      title:    'Sei a un passo dalla spedizione gratuita',
      subtitle: 'Aggiungi uno o più prodotti per non pagare spese di spedizione! 🚚',
    },

    // Modalità RELATED (correlati a prodotti nel cart)
    related: {
      title:    'Completa la tua routine',
      subtitle: 'I prodotti che si abbinano meglio a quello che hai scelto',
    },

    // Modalità BESTSELLER (cart vuoto)
    bestseller: {
      title:    'I cosmetici Skön più acquistati:',
      subtitle: 'Persone come te hanno amato usare questi prodotti:',
    },

    // Stato "soglia raggiunta" — usato dalla progress bar e dal widget
    // come messaggio di conferma quando free-shipping è attivata.
    achieved: 'Hai raggiunto la spedizione gratuita',
  },


  /* ── COMUNICAZIONE COMMERCIALE ──────────────────────────────────── */

  // Testi mostrati al visitatore. Editabili senza toccare il codice.
  // Usare {{gap}} come placeholder per l'importo mancante (formattato).
  // Usare {{threshold}} come placeholder per la soglia (formattato).
  copy: {
    // Sopra la soglia
    achieved: 'Spedizione gratuita sbloccata 🎉',

    // Sotto la soglia, ma OLTRE il 50% del valore (cart già "in corsa")
    // Messaggio economico: indica il gap residuo da chiudere.
    progress: 'Aggiungi {{gap}} per la spedizione gratuita',

    // SKÖN custom (maggio 2026) — Sotto la soglia E sotto il 50% del
    // valore (cart appena iniziato). Messaggio valoriale che inquadra
    // il vincolo come opportunità di sostenibilità, evitando l'effetto
    // scoraggiante dei "tanti soldi mancanti".
    //
    // Due varianti per evitare ridondanza con il banner promo NC:
    //
    //   - progressBelowThreshold: usata per gruppo A e RC (niente
    //     banner sopra). Include la soglia perché senza non si
    //     capirebbe da dove arriva il vantaggio.
    //
    //   - progressBelowThresholdNcB: usata per gruppo B + NC (banner
    //     "Per il tuo primo ordine arriva a 29€..." già presente
    //     sopra). Niente soglia: la promessa economica è già stata
    //     fatta dal banner, qui resta solo la leva valoriale.
    //
    // {{threshold}} interpolato con la soglia reale (29€ o 49€).
    // Il copy contiene HTML (<strong>, <br>) iniettato in innerHTML
    // dal modulo: niente input utente, no XSS risk.
    progressBelowThreshold: '<strong>Fai un ordine unico</strong> 🌿 Meno consegne = meno CO₂.<br>Da {{threshold}} la spedizione è gratis. 🚚',
    progressBelowThresholdNcB: '<strong>Fai un ordine unico</strong> 🌿 Meno consegne = meno CO₂.',

    // Etichetta gruppo B che evidenzia il vantaggio NC (mostrato nel popup
    // di onboarding "primo acquisto")
    ncBenefitBadge: 'Per te spedizione gratis già da 29€',

    // Titolo widget cross-sell (sopra le card prodotti)
    suggestionsTitle: 'Sei a un passo dalla spedizione gratuita',
    suggestionsSubtitle: 'Aggiungi uno o più prodotti per non pagare la spedizione! 🚚',

    // Stato "soglia raggiunta" del widget cross-sell (caso edge)
    suggestionsAchieved: 'Hai raggiunto la spedizione gratuita',
  },


  /* ── GA4 TRACKING ───────────────────────────────────────────────── */

  ga4: {
    // false = il modulo non emette eventi GA4 (utile in staging/test)
    enabled: true,

    // Nomi eventi custom GA4. Non modificare a test in corso (perderesti
    // continuità nelle esplorazioni già configurate).
    events: {
      assigned:           'skon_fs_assigned',           // primo arrivo NC, group assignato
      thresholdReached:   'skon_fs_threshold_reached',  // subtotal ≥ soglia
      fillerAdded:        'skon_fs_filler_added',       // click su un suggested product
      checkoutInitiated:  'skon_fs_checkout_initiated', // click su checkout (NC con cookie attivo)
      discountApplied:    'skon_fs_discount_applied',   // SK-FS29 applicato con successo
    },
  },


  /* ── DEBUG ──────────────────────────────────────────────────────── */

  debug: {
    // true = log su console.info per ogni step del modulo
    // Utile in staging. Spegnere in produzione per non sporcare la console.
    verbose: false,

    // true = ignora il check "audience=NC" e attiva il modulo per chiunque
    // visiti il sito con ?skon_fs_debug=1 nell'URL.
    // Utile per testare il flusso senza dover sporcare i cookie.
    forceShowOnDebugParam: true,
  },

};

/* ── Override dal Customizer (ponte snippets/skon-fs-settings.liquid) ───────
   Se window.SKON_FS_SETTINGS è presente, sovrascrive SOLO thresholds.groupA
   sul default qui sopra (è il gruppo attivo, dato forceGroup: 'A').
   thresholds.groupB NON viene toccato: resta il valore dormiente indipendente,
   per non legare un eventuale A/B futuro al campo del Customizer pensato per
   l'esperienza "tutti NC" corrente. Assente ⇒ resta il default hardcoded
   (retrocompatibile). Stesso pattern di skon-gift-config.js. */
(function (s) {
  if (!s) return;
  var C = window.SKON_FS_CONFIG;

  if (typeof s.thresholdCents === 'number' && s.thresholdCents > 0) {
    C.thresholds.groupA = s.thresholdCents;
  }
})(window.SKON_FS_SETTINGS);